import { Component, OnInit } from '@angular/core';
import v1 from 'uuid/v1';
import { ToastsService } from '../../services/toasts.service';

export interface ToastData {
  id?: string;
  title: string;
  content: string;
}

@Component({
  selector: 'ori-toasts',
  templateUrl: './toasts.component.html',
  styleUrls: ['./toasts.component.scss']
})
export class ToastsComponent implements OnInit {

  public items: ToastData[] = [];

  public constructor(
    private toastsService: ToastsService
  ) {
  }

  public ngOnInit() {
    this.toastsService.new$.subscribe(value => {
      this.items.push({...value, id: v1()});
    });
  }

  public remove(idx: number) {
    this.items.splice(idx, 1);
  }
}
